// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1BctV","right":"styles_right__3qc1r"};